/**
 * Constants for the answers used on the support page.
 */
const Answers = {
  WhereIsMyOrder: 1,
  ReportAnIssue: 2,
  CancelChange: 3,
  SupportCase: 4,
  ProductQuestion: 5,
  AccountHelp: 6,
  Payment: 7,
  Other: 8,
  Shipping: 9,
  Tracking: 10,
};

export default Answers;
